// src/redux/slices/orderSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../../api/authApi';

export const fetchOrderHistoryAsync = createAsyncThunk(
  'orders/fetchOrderHistory',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiService.getOrderHistory();
      return response;
    } catch (error) {
      return rejectWithValue(typeof error === 'string' ? error : 'Failed to fetch order history');
    }
  }
);

const initialState = {
  orders: [],
  totalOrders: 0,
  isLoading: false,
  error: null,
  lastUpdated: null,
  selectedOrder: null,
};

const orderSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearOrders: (state) => {
      state.orders = [];
      state.totalOrders = 0;
    },
    selectOrder: (state, action) => {
      state.selectedOrder = state.orders.find(order => order.order_id === action.payload) || null;
    },
    clearSelectedOrder: (state) => {
      state.selectedOrder = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrderHistoryAsync.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchOrderHistoryAsync.fulfilled, (state, action) => {
        state.isLoading = false;
        const data = action.payload?.data || [];
        state.orders = data;
        state.totalOrders = data.length;
        state.lastUpdated = new Date().toISOString();
        state.error = null;
      })
      .addCase(fetchOrderHistoryAsync.rejected, (state, action) => {
        state.isLoading = false;
        state.error = typeof action.payload === 'string' ? action.payload : 'Failed to fetch order history';
        state.orders = [];
        state.totalOrders = 0;
      });
  },
});

export const { clearError, clearOrders, selectOrder, clearSelectedOrder } = orderSlice.actions;
export default orderSlice.reducer;